var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSingleGate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 18,
    height: 18,
    id: "canvas_background",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "canvasGrid",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "svg_1",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    strokeWidth: 0,
    fill: "url(#gridpattern)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    x: 2.808454,
    y: 1.252097,
    width: 10.476076,
    height: 13.030892,
    id: "svg_3",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000",
    strokeOpacity: "null",
    fillOpacity: "null",
    x1: 0.483881,
    y1: 0.747333,
    x2: 0.421893,
    y2: 14.91173,
    id: "svg_4",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeOpacity: "null",
    fillOpacity: "null",
    x1: 15.547113,
    y1: 0.716339,
    x2: 15.485125,
    y2: 14.880736,
    id: "svg_5",
    strokeLinejoin: "null",
    strokeLinecap: "null",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000",
    strokeOpacity: "null",
    fillOpacity: "null",
    x1: 0.76283,
    y1: 2.575997,
    x2: 2.715471,
    y2: 2.575997,
    id: "svg_7",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000",
    strokeOpacity: "null",
    fillOpacity: "null",
    x1: 0.700841,
    y1: 12.46318,
    x2: 2.653482,
    y2: 12.46318,
    id: "svg_8",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000",
    strokeOpacity: "null",
    fillOpacity: "null",
    x1: 13.563478,
    y1: 12.432186,
    x2: 15.516119,
    y2: 12.432186,
    id: "svg_9",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000",
    strokeOpacity: "null",
    fillOpacity: "null",
    x1: 13.191546,
    y1: 2.514008,
    x2: 15.144187,
    y2: 2.514008,
    id: "svg_10",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    strokeWidth: 0,
    strokeOpacity: "null",
    fillOpacity: "null",
    x: -7.740028,
    y: 30.874945,
    id: "svg_11",
    fontSize: 24,
    fontFamily: "Helvetica, Arial, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve",
    transform: "matrix(0.5563940405845642,0,0,0.5563940405845642,7.887868465855718,-4.865802867338061) ",
    stroke: "#000"
  }, "S"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleGate);
export default __webpack_public_path__ + "static/media/single_gate.02017d2d5289f77e9904017adb3d01ec.svg";
export { ForwardRef as ReactComponent };